import React, { useEffect, useState } from 'react';
import {
  ScrollView,
  View,
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import { getDocumentsData, deleteDocument } from '../../../api/Settings';
import { msgStr } from '../../../common/constants/Message';
import { TextMediumSize } from '../../../common/constants/Fonts';
import { useAlertModal, useConfirmModal } from '../../../common/hooks';
import BasicLayout from '../../../common/components/CustomLayout/BasicLayout';

import { documentsStyle } from './styles/DocumentsStyle';
import AddDocumentModal from './AddDocumentModal';

const Documents = ({ navigation, openInventory }) => {
  const screenHeight = Dimensions.get('window').height;

  const { showAlert } = useAlertModal();
  const { showConfirm } = useConfirmModal();

  const [tableData, setTableData] = useState([]);
  const [updateDocumentTrigger, setUpdateDocumentTrigger] = useState(true);

  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchText, setSearchText] = useState('');

  const openAddDocumentModal = () => {
    setAddModalVisible(true);
    setSelectedDocument(null);
  };
  const closeAddDocumentModal = () => {
    setAddModalVisible(false);
    setSelectedDocument(null);
  };
  const editDocument = (item) => {
    setSelectedDocument(item);
    setAddModalVisible(true);
  };

  useEffect(() => {
    if (updateDocumentTrigger == true) getTable();
  }, [updateDocumentTrigger]);

  const removeDocument = (id) => {
    showConfirm(msgStr('deleteConfirmStr'), () => {
      deleteDocument(id, (jsonRes, status, error) => {
        switch (status) {
          case 200:
            setUpdateDocumentTrigger(true);
            showAlert('success', jsonRes.message);
            break;
          default:
            if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
            else showAlert('error', msgStr('unknownError'));
            break;
        }
      });
    });
  };

  const getTable = () => {
    getDocumentsData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setUpdateDocumentTrigger(false);
          setTableData(jsonRes);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const filteredData = tableData.filter(item =>
    !searchText || item.document_name?.toLowerCase().includes(searchText.toLowerCase())
  );

  const renderTableData = () => {
    const rows = [];
    if (filteredData.length > 0) {
      filteredData.map((item, index) => {
        rows.push(
          <View key={index} style={styles.tableRow}>
            <View style={[styles.cell, { width: 300 }]}>
              <Text>{item.document_name}</Text>
            </View>
            <View style={[styles.IconCell]}>
              {item.document_type == 0 ? (
                <Text>{'INT'}</Text>
              ) : (
                <FontAwesome5 size={TextMediumSize} name="file-pdf" color="black" />
              )}
            </View>
            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  editDocument(item);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="edit" color="black" />
              </TouchableOpacity>
            </View>
            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  removeDocument(item.id);
                }}
              >
                <FontAwesome5 size={TextMediumSize} name="times" color="black" />
              </TouchableOpacity>
            </View>
          </View>
        );
      });
    } else {
      <></>;
    }
    return <>{rows}</>;
  };

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        openInventory(null);
      }}
      screenName={'Documents'}
    >
      <ScrollView horizontal={true}>
        <View style={styles.container}>
          <View style={styles.toolbar}>
            <TouchableHighlight style={styles.button} onPress={openAddDocumentModal}>
              <Text style={styles.buttonText}>Add</Text>
            </TouchableHighlight>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginLeft: 15, backgroundColor: '#f5f5f5', borderRadius: 8, paddingHorizontal: 12, flex: 1, maxWidth: 320, height: 36 }}>
              <FontAwesome5 name="search" size={14} color="#666" style={{ marginRight: 8 }} />
              <TextInput
                style={{ flex: 1, fontSize: 14, outlineStyle: 'none', border: 'none', backgroundColor: 'transparent' }}
                value={searchText}
                onChangeText={setSearchText}
                placeholder="Search documents..."
                placeholderTextColor="#999"
              />
              {searchText ? (
                <TouchableOpacity onPress={() => setSearchText('')} style={{ padding: 4 }}>
                  <FontAwesome5 name="times-circle" size={14} color="#999" />
                </TouchableOpacity>
              ) : null}
            </View>
          </View>
          <View style={styles.tableContainer}>
            <View style={styles.tableHeader}>
              <Text style={[styles.columnHeader, { width: 300 }]}>{'Document Name'}</Text>
              <Text style={[styles.columnHeader, styles.IconCell]}>{'Type'}</Text>
              <Text style={[styles.columnHeader, styles.IconCell]}>{'Edit'}</Text>
              <Text style={[styles.columnHeader, styles.IconCell]}>{'DEL'}</Text>
            </View>
            <ScrollView style={{ flex: 1, maxHeight: screenHeight - 220 }}>
              {renderTableData()}
            </ScrollView>
          </View>
        </View>
      </ScrollView>

      <AddDocumentModal
        isModalVisible={isAddModalVisible}
        Document={selectedDocument}
        setUpdateDocumentTrigger={setUpdateDocumentTrigger}
        closeModal={closeAddDocumentModal}
      />
    </BasicLayout>
  );
};

const styles = documentsStyle;

export default Documents;
